import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TransportModeCardModel } from '../../models/transport-mode-card.model';
import { TransportMode } from '../../models/transport-mode.enum';

@Component({
  selector: 'hazmatsuite-next-transport-mode-cards',
  templateUrl: './transport-mode-cards.component.html',
  styleUrls: ['./transport-mode-cards.component.scss'],
})
export class TransportModeCardsComponent {
  @Input() cards: TransportModeCardModel[] = [];
  @Output() selected = new EventEmitter<TransportMode>();
  transportModes: typeof TransportMode = TransportMode;
}
